/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions";
import "components/elements/main/index.scss";
import {Box, Button, IconButton} from "@mui/material";
import {FlexBetween, FlexBox} from "components/flex-box";
import MockShopHeader from "components/elements/main/MockShopHeader";

import { Avatar, Card, Typography } from "@mui/material";
import { H1, H2, H5, H6 } from "components/CustomTypography";
import {getLogo, openGoogleMapLocation, openInstagram, openWhatsApp} from "helpers/utils";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import * as ActionTypes from "constants/ActionTypes";
import CircularProgress from "@mui/material/CircularProgress";
import PlaceIcon from "@mui/icons-material/Place";
import ButtonComponent from "../../../../Button";
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ShopHeaderOurCollection from "components/elements/user/shops/ShopHeaderOurCollection";

const ShopHeaderShopOverlay = (props) => {

    const {
        serviceError, reqStatus, isLoading, isLoadingBootInfo, bootupInfo, userMainGetShopInfoById,
        history, shopdetail, userMainAddStoreToFavlist, shopId
    } = props;

  const [state] = useState({
    layoutColumns: 3,
  });

    const handleBackHome = () => {
        history.push(`/shops`);
    };

    const handleShopButtonClick = () => {
        history.push(`/shop/${shopdetail.id}`);
    };

    useEffect(() => {
        userMainGetShopInfoById(shopId);
    }, []);

    useEffect(() => {
        switch (reqStatus) {
            case ActionTypes.USER_MAIN_ADD_STORE_TO_FAVLIST_SUCCESS:
                userMainGetShopInfoById(shopId);
                break;
            default:
                break;
        }
    }, [serviceError, reqStatus]);


    const addShopFavourite = () => {
        userMainAddStoreToFavlist(shopdetail.id);
    };

    const openGoogleMap = () => {
        openGoogleMapLocation(shopdetail.location);
    };

    return (
        <Box mb={2}>
            <Box pt={3} pb={3}
                sx={{
                    alignItems: "center",
                    bgcolor: "#f4f4f4"
                }}
            >
                {isLoadingBootInfo && <MockShopHeader height={100} />}
                <>
                    <FlexBox width="100%" >
                        <Box width="70%" alignItems="left">
                            <H6 fontSize="12px" color="grey.900">
                                Seller:
                            </H6>
                            <H2 textTransform="capitalize" fontSize="22px" fontWeight="bold" color="primary.black" ellipsis>
                                {shopdetail.title}
                            </H2>
                            <H6 fontSize="12px" color="grey.900">
                                {shopdetail.area && (shopdetail.area)}
                            </H6>
                        </Box>
                        <Box width="30%" alignItems="left">
                            <ButtonComponent
                                sx={{
                                    mt: 2,
                                    mb: 2,
                                }}
                                type="primary"
                                variant="contained"
                                name="Shop with us! >"
                                size="small"
                                onClick={handleShopButtonClick}
                            />
                        </Box>
                    </FlexBox>
                </>
            </Box>
        </Box>
    );
};

ShopHeaderShopOverlay.propTypes = {
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Mapping Props and State.
const shopHeaderShopOverlay = connect(
  ({ bootupInfo, userMainShops }) => ({
    bootupInfo,
    reqStatus: userMainShops.reqStatus,
    isLoading: userMainShops.isLoading,
    serviceError: userMainShops.serviceError,
      shopdetail: userMainShops.shopDetail,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ShopHeaderShopOverlay);

export { shopHeaderShopOverlay as default };
